import React from 'react';
import TaskWorkframePanel from './TaskWorkframePanel';
import TaskWorkframeDropdown from './TaskWorkframeDropdown';

// Arma los 3 slots que `ComponentTaskHoy` pasa a `TaskDetailPanel` para el Cuadro de Trabajo
// (integración main→dev, epic D1.4): la clase de layout, el dropdown del header, y el wrapper
// de las 3 columnas alrededor del `[left, comments]`. Extraído a un helper para no engordar
// `ComponentTaskHoy` (que está en su baseline del ratchet).

export function taskWorkframeSlots({
    activeTask,
    enabled,
    tasks,
    onUpdateTask,
    onOpenTask,
    onCreateUpdate,
    onOpenCreateComment,
    toast, // Fase 5.17 -- threadeado desde `ComponentTaskHoy` a las columnas presentacionales
}) {
    const active = enabled && !!activeTask?.workframe_id;
    const safeToast = toast;

    return {
        withWorkframe: active,
        headerExtra: enabled ? (
            <TaskWorkframeDropdown
                spaceId={activeTask.space_id}
                currentWorkframeId={activeTask.workframe_id}
                onSelectWorkframe={(wfId) => onUpdateTask(activeTask.id, { workframe_id: wfId })}
            />
        ) : null,
        renderWorkframe: active
            ? (body) => (
                <TaskWorkframePanel
                    workframeId={activeTask.workframe_id}
                    spaceId={activeTask.space_id}
                    activeTaskId={activeTask.id}
                    activeTask={activeTask}
                    toast={safeToast}
                    onSelectTask={(id, taskObj) => onOpenTask(taskObj || (tasks || []).find((tk) => tk.id === id) || { id })}
                    onCreateTask={(docId) => onCreateUpdate({ workframeId: activeTask.workframe_id, docId, spaceId: activeTask.space_id })}
                    onAddSuggestion={(id, taskObj) => { onOpenTask(taskObj || { id }); onOpenCreateComment(); }}
                >
                    {body}
                </TaskWorkframePanel>
            )
            : undefined,
    };
}
